import type { LineItem } from '@simplisafe/eis-commercetools-carts'

export function toTotalQuantityInCart(lineItems: readonly LineItem[]) {
  return lineItems
    .filter(lineItem => lineItem.productType !== 'service')
    .reduce((acc, lineItem: LineItem) => acc + lineItem.quantity, 0)
}
